import { render } from "./QuestionRow.vue?vue&type=template&id=021639de"
import script from "./QuestionRow.vue?vue&type=script&lang=js"
export * from "./QuestionRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__